import fsExes from "./fs.jsx";

const exes = {
  ...fsExes,
};

export default exes;
